module.exports = __webpack_public_path__ + "img/BlueSwoosh.3d0d7562.png";